import React, { useState } from "react";
import Sidebar from "./Sidebar";
import { useLocation } from "react-router-dom";
// import { MdNotificationsActive } from "react-icons/md";

// import { subscribeUser } from "../subscription";

// const checkPermmsions = () => {
//   if("serviceWorker" in navigator){
//     navigator.serviceWorker.ready
//       .then(function (registration) {
//         if (!registration.pushManager) {
//           console.log("Push manager unavailable.");
//           return
//         }
//         registration.pushManager
//           .getSubscription()
//           .then(function (existedSubscription) {})
//       })
//   }
// }

function Navbar({
  newMessages,
  isBadgeActive,
  setMessages,
  deferredPrompt,
  setDeferredPrompt,
}) {
  const location = useLocation();

  const [isSidebarActive, setIsSidebarActive] = useState(false);
  const [isConfirmationModalActive, setIsConfirmationModalActive] =
    useState(false);

  if (
    location.pathname === "/login" ||
    location.pathname.split("/").includes("reset-password")
  ) {
    return null;
  } else {
    return (
      <>
        {isConfirmationModalActive && (
          <div className="confirmation-modal-container">
            <div className="confirmation-modal-content">
              <div className="confirmation-modal-heading">
                <h2>Enable Push Notifications</h2>
              </div>
              <div className="confirmation-modal-body">
                <p>
                  Enable push notifications to get instantly notified whenever
                  there is a new announcement.
                </p>
              </div>
              <div className="confirmation-modal-btn-container">
                <button
                  className="confirmation-modal-button allow-btn"
                  onClick={() => {
                    setIsConfirmationModalActive(false);
                  }}
                >
                  Allow
                </button>
                <button
                  className="confirmation-modal-button deny-btn"
                  onClick={() => {
                    setIsConfirmationModalActive(false);
                  }}
                >
                  Deny
                </button>
              </div>
            </div>
          </div>
        )}
        <Sidebar
          isSidebarActive={isSidebarActive}
          setIsSidebarActive={setIsSidebarActive}
          isBadgeActive={isBadgeActive}
          newMessages={newMessages}
          setMessages={setMessages}
          deferredPrompt={deferredPrompt}
          setDeferredPrompt={setDeferredPrompt}
        />
        <div className="navbar-container">
          {isBadgeActive || newMessages ? (
            <img
              className="navbar-menu-icon"
              src="/menu-icon-red.svg"
              alt=""
              onClick={() => setIsSidebarActive(!isSidebarActive)}
            />
          ) : (
            <img
              className="navbar-menu-icon"
              src="/menu-icon.svg"
              alt=""
              onClick={() => setIsSidebarActive(!isSidebarActive)}
            />
          )}

          <img className="navbar-logo" src="/logo-white.svg" alt="" />
          {/* <div
            className="push-notification-btn"
            onClick={() => setIsConfirmationModalActive(true)}
          >
            <MdNotificationsActive />
          </div> */}
        </div>
      </>
    );
  }
}

export default Navbar;
